import { curry, compose, equals, prop } from 'ramda';

/** equals + prop 的縮寫，因為很常用到 */
export const equalProps = curry((key, object) => compose(equals, prop(key))(object));
